import './AddServiceOptional.scss';

import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { editService, loadProvider } from 'actions/provider';
import Button from 'atoms/button';
import Dropdown from 'atoms/dropdown';
import Icon from 'atoms/icon';
import { setService } from 'store/reducers/serviceForm';

export default function ServiceInfo() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const service = useSelector((state) => state.serviceForm);
  const { uuid: serviceId, animal } = service;
  const { provider, core } = useSelector((state) => state.main);
  const { tag } = provider.service;
  const [size, setSize] = useState('');
  const [age, setAge] = useState('');
  const [breed, setBreed] = useState('');
  const [hairLength, setHairLength] = useState('');
  const [tags, setTags] = useState({
    0: {},
    1: {},
    2: {},
    3: {},
    4: {},
  });
  const animalTypeId = animal.type?.id;
  // Animal isn't an exotic pet, large animal, or pocket pet
  const displayAdditionalDetails = animalTypeId < 3;

  const canContinue =
    size ||
    age ||
    breed ||
    hairLength ||
    Object.values(tags).filter((key) => Object.keys(key).length > 0)[0];

  const onSave = async (e) => {
    e.preventDefault();

    const serviceSaved = await dispatch(
      editService(
        {
          name: service.name,
          description: service.description,
          amount: service.price?.amount,
          durationMinutes: service.durationMinutes,
          typeId: service.type.id,
          animalTypeId,
          animalAgeId: age?.id || null,
          breedId: breed?.id || null,
          hairLengthId: hairLength?.id || null,
          sizeId: size?.id || null,
          tagIds: Object.entries(tags)
            .map(([key, data]) => data?.id)
            .filter(Boolean),
        },
        serviceId
      )
    );
    if (serviceSaved.success) {
      nextPage();
    }
  };

  const nextPage = () => {
    dispatch(setService({ animal: { type: null }, uuid: null }));
    dispatch(loadProvider()).then(({ success }) => {
      if (success) navigate('/services');
    });
  };

  return (
    <div className="add-service">
      <Link to="/add-service">
        <Icon name="arrowLeft" className="mb-15" />
      </Link>
      <h1>Optional details</h1>
      <form onSubmit={onSave}>
        <p className="label mt-35 mb-10">Tags (up to 5)</p>
        <div className="flex-row tags-container">
          <div className="flex-row w-100">
            {[0, 1, 2].map((item) => (
              <Dropdown
                key={item}
                id={`tag-${item}`}
                className="hide-label mr-10"
                placeholder={`Tag ${item + 1}`}
                items={tag}
                generateKey
                isClearable
                onClick={(value) =>
                  setTags((prev) => ({ ...prev, [item]: value }))
                }
                disabledValues={Object.entries(tags)
                  .map(([key, data]) => data?.value)
                  .filter(Boolean)}
                value={tags[item]}
              />
            ))}
          </div>
          <div className="flex-row w-100">
            {[3, 4].map((item) => (
              <Dropdown
                key={item}
                id={`tag-${item}`}
                className="hide-label mr-10"
                generateKey
                isClearable
                placeholder={`Tag ${item + 1}`}
                items={tag}
                onClick={(value) =>
                  setTags((prev) => ({ ...prev, [item]: value }))
                }
                disabledValues={Object.entries(tags)
                  .map(([key, data]) => data?.value)
                  .filter(Boolean)}
                value={tags[item]}
              />
            ))}
            <div className="input hidden" />
          </div>
        </div>
        {displayAdditionalDetails && (
          <>
            <p className="label mt-35 mb-10">Additional details (optional)</p>
            <div className="flex-row align-end">
              <Dropdown
                placeholder="Size"
                className="w-100 mr-10 hide-label"
                items={core.size}
                isClearable
                onClick={(value) => setSize(value)}
                value={size}
              />
              <Dropdown
                placeholder="Hair length"
                className="w-100 hide-label"
                items={core.hair.length.filter(
                  (el) => el.animalTypeId === animalTypeId
                )}
                isClearable
                onClick={(value) => setHairLength(value)}
                value={hairLength}
              />
            </div>
            <div className="flex-row align-end">
              <Dropdown
                placeholder={
                  animalTypeId === 2 ? 'Puppy, adult' : 'Kitten, adult'
                }
                className="w-100 hide-label mr-10"
                items={core.age.filter(
                  (el) => el.animalTypeId === animalTypeId
                )}
                isClearable
                onClick={(value) => setAge(value)}
                value={age}
              />
              <Dropdown
                placeholder="Breed"
                className="w-100 hide-label"
                items={core.breed.filter(
                  (el) => el.animalTypeId === animalTypeId
                )}
                isClearable
                onClick={(value) => setBreed(value)}
                value={breed}
              />
            </div>
          </>
        )}
        <div className="flex-row">
          <Button
            variant={canContinue ? 'default' : 'disabled'}
            type="submit"
            text="Done"
            className="mb-35 mt-30"
          />
          <p onClick={nextPage} className="ml-25 f18 pointer">
            Skip aditional details
          </p>
        </div>
      </form>
    </div>
  );
}
